"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointTransformationSimulateOut = void 0;
class EndpointTransformationSimulateOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointTransformationSimulateOut.attributeTypeMap;
    }
}
exports.EndpointTransformationSimulateOut = EndpointTransformationSimulateOut;
EndpointTransformationSimulateOut.discriminator = undefined;
EndpointTransformationSimulateOut.attributeTypeMap = [
    {
        "name": "method",
        "baseName": "method",
        "type": "TransformationHttpMethod",
        "format": ""
    },
    {
        "name": "payload",
        "baseName": "payload",
        "type": "string",
        "format": ""
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "URI",
        "format": "uri"
    }
];
//# sourceMappingURL=EndpointTransformationSimulateOut.js.map